import request from '@/utils/request'

export function leaderlist (query) {
  return request({
    url: '/leader/query',
    method: 'get',
    params: query
  })
}
export function leadertype (query) {
  return request({
    url: '/leader/type/query',
    method: 'get',
    params: query
  })
}
export function leaderdetaillist (query) {
  return request({
    url: '/leader/get',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/leader.js